export type HubPageSize = number | "all";

export const HUB_PAGE_SIZE_OPTIONS: HubPageSize[] = [10, 20, 50, 100, 500, "all"];

export const DEFAULT_HUB_PAGE_SIZE = 10;

const ALLOWED_NUMERIC = new Set([10, 20, 50, 100, 500]);

export function parseHubPageSize(raw: string | null): HubPageSize {
  if (raw === "all") return "all";
  const n = parseInt(raw ?? "", 10);
  if (ALLOWED_NUMERIC.has(n)) return n;
  return DEFAULT_HUB_PAGE_SIZE;
}

export function hubPageSizeToParam(size: HubPageSize): string {
  return size === "all" ? "all" : String(size);
}

export function paginateHubItems<T>(
  items: T[],
  page: number,
  pageSize: HubPageSize,
): T[] {
  if (pageSize === "all") return items;
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function hubTotalPages(itemCount: number, pageSize: HubPageSize): number {
  if (pageSize === "all" || itemCount === 0) return 1;
  return Math.max(1, Math.ceil(itemCount / pageSize));
}

export function hubShowsPagination(
  itemCount: number,
  pageSize: HubPageSize,
): boolean {
  return pageSize !== "all" && itemCount > pageSize;
}
